import { Component, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { Response } from '@angular/http';
import { CommonHttpService } from '../../shared/services/http.service';
import { OrderModel } from '../../shared/models/payment/order/order.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'account-orders',
    templateUrl: './account.orders.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersComponent {
    public client: ClientModel;
    public orders: Array<OrderModel> = [];
    public loading = false;
    public hasMoreToLoad = true;
    private limit = 5;
    private currentOffset = 0;

    constructor(
        protected translate: TranslateService,
        protected titleService: Title,
        protected http: CommonHttpService,
        protected router: Router,
        protected oauth: OauthService, 
        protected activatedRoute: ActivatedRoute
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });
        
        this.translate.get('ACCOUNT.ORDERS.TITLE').subscribe((title: string) => {
            this.titleService.setTitle(title + ' | ' + this.activatedRoute.snapshot.data.storeConfigurations.store_name);
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexOrders();
        });
        this.oauth.failedAuthenticatedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.failedPersistedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.tokenRefused$.subscribe(() => {
            this.redirectOnFailAuthentication();
        });
    }

    public loadMore() {
        this.currentOffset += 5;
        this.indexOrders(this.currentOffset);
    }

    private indexOrders(offset: number = 0) {
        this.loading = true;
        this.http
            .useAuth()
            .get(
                `account/clients/${this.client.id}/orders`
                + `?_sort=-id`
                + `&_offset=${+offset}`
                + `&_limit=${+this.limit}`
                + `&_fields=id,datetime,total,status`
                + `&_config=meta-has-more-pages`
            )
            .subscribe((response: Response) => {
                const orders = response.json().data;
                const meta = response.json().meta;

                if (offset === 0) {
                    this.orders = [];
                }

                for (let index in orders) {
                    if (orders.hasOwnProperty(index)) {
                        this.orders.push(orders[index]);
                    }
                }

                this.hasMoreToLoad = meta['meta-has-more-pages'];
                this.loading = false;
            });
    }

    /**
     * Redirect user to index page.
     **/
    private redirectOnFailAuthentication(statusCode = 401) {
        if (statusCode === 401) {
            window.location.href = '/';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/account/orders/account.orders.component.ts